import Card from "react-bootstrap/Card";
import { OutboundLink } from "react-ga";
import PropTypes from "prop-types";
import React from "react";
import YouTube from "react-youtube";
import classNames from "classnames";
import styles from "../styles/ContentPreview.module.scss";
import useDarkMode from "use-dark-mode";

const ContentPreview = ({ date, link, title, videoOnly, youtube }) => {
  const darkMode = useDarkMode(false);
  return (
    <div
      className={classNames(styles.container, {
        [styles.dark]: darkMode.value,
        [styles.podcast]: videoOnly,
      })}
    >
      <Card className={classNames("shadow-sm", styles.card)}>
        <div className={styles.youtube}>
          <YouTube videoId={youtube} />
        </div>
        {!videoOnly && (
          <div className={styles.body}>
            <div className={styles.date}>{date}</div>
            <OutboundLink eventLabel={link} rel="noreferrer" target="_blank" to={link}>
              <h4 className={styles.heading}>{title}</h4>
            </OutboundLink>
          </div>
        )}
      </Card>
    </div>
  );
};

ContentPreview.propTypes = {
  date: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  videoOnly: PropTypes.bool,
  youtube: PropTypes.string.isRequired,
};

export default ContentPreview;
